import React from 'react';
import { Navigate } from 'react-router-dom';
import { sectionVisibility } from '../../config/sectionVisibility';

/**
 * Bloquea /hub/novedades y /hub/novedades/:id cuando la sección está desactivada.
 */
const NovedadesRouteGuard = ({ children }) => {
  if (!sectionVisibility.hub.novedades) {
    return <Navigate to="/hub" replace />;
  }
  return children;
};

export default NovedadesRouteGuard;
